module.exports = __webpack_public_path__ + "static/media/electronics.980eb0a2.svg";